import { getShouldUseZendeskSandbox } from "@faire/help-center-utils/serialized-data/getShouldUseZendeskSandbox";

export const RETAILER_WHAT_IS_FAIRE_ID = getShouldUseZendeskSandbox()
  ? "14674140629275"
  : "360015892572";

export const EU_DSA_ID = getShouldUseZendeskSandbox()
  ? "21720888406811"
  : "20960200105115";

export const FAIRE_ACCOUNT_SECURITY_ID = getShouldUseZendeskSandbox()
  ? "14674263970459"
  : "4408644893851";

export const BRAND_POLICIES_ID = getShouldUseZendeskSandbox()
  ? "14685390956443"
  : "360019040511";

export const WHERE_IS_FAIRE_AVAILABLE_ID = getShouldUseZendeskSandbox()
  ? "14674166031003"
  : "360016111311";

export const BECOME_BRAND_ID = getShouldUseZendeskSandbox()
  ? "14684624134299"
  : "360015479092";

export const FAIRE_COST_ID = getShouldUseZendeskSandbox()
  ? "14684483173659"
  : "360015893392";

export const ORDER_INVOICE_ID = getShouldUseZendeskSandbox()
  ? "14685198291355"
  : "360019493092";

export const ACCEPTING_ORDER_ID = getShouldUseZendeskSandbox()
  ? "14685105474843"
  : "360006685351";

export const WORD_FROM_CEO_ID = getShouldUseZendeskSandbox()
  ? "14674570252315"
  : "360004620392";

export const HOW_DO_NET_60_TERMS_WORK_ID = getShouldUseZendeskSandbox()
  ? "14675312474523"
  : "360016658851";

export const HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID =
  getShouldUseZendeskSandbox() ? "14675008853531" : "360047925272";

export const HOW_AM_I_NOTIFIED_NEW_ORDERS_ID = getShouldUseZendeskSandbox()
  ? "14685133526299"
  : "360006666951";

export const CONTACTING_MY_RETAILER_ID = getShouldUseZendeskSandbox()
  ? "14684662536091"
  : "360006915652";

export const PAYOUT_CALCULATED_ID = getShouldUseZendeskSandbox()
  ? "14685300144411"
  : "360006856911";

export const PAYOUT_EUROPEAN_ID = getShouldUseZendeskSandbox()
  ? "22825489075739"
  : "1260807391309";

export const PAYOUT_AUSTRALIAN_ID = getShouldUseZendeskSandbox()
  ? "22825471980315"
  : "1260807391309";

export const PAYOUT_CANADIAN_ID = getShouldUseZendeskSandbox()
  ? "22825466000795"
  : "19879402447643";

export const ISSUE_WITH_MY_ORDER_PAYOUT_ID = getShouldUseZendeskSandbox()
  ? "14685295538459"
  : "360006915532";

export const TAX_FORM_1099_ID = getShouldUseZendeskSandbox()
  ? "14685302136475"
  : "360022603552";

export const SETTING_UP_PAYOUT_ID = getShouldUseZendeskSandbox()
  ? "22825471980315"
  : "22825454667035";

export const TROUBLESHOOTING_WITH_ADYEN_ID = getShouldUseZendeskSandbox()
  ? "14685306076059"
  : "4404428415899";

export const NAM_SELL_ON_FAIRE_ID = getShouldUseZendeskSandbox()
  ? "22174219389723"
  : "360015893392";

export const NON_NAM_SELL_ON_FAIRE_ID = getShouldUseZendeskSandbox()
  ? "22825471901083"
  : "360040446591";

export const DISPUTE_A_RETAILER_COMPLAINT_ID = getShouldUseZendeskSandbox()
  ? "14685393455131"
  : "360007190491";

export const MAKE_A_RETURN_ID = getShouldUseZendeskSandbox()
  ? "14677185138971"
  : "360002924031";

export const ORDER_STATUS_ID = getShouldUseZendeskSandbox()
  ? "14674934260507"
  : "360006919652";

export const CANCELING_AN_ORDER_ID = getShouldUseZendeskSandbox()
  ? "14674935583003"
  : "360006919932";

export const REPORT_DAMAGED_MISSING_ID = getShouldUseZendeskSandbox()
  ? "14675107592475"
  : "360003687811";

export const CONTACT_A_BRAND_ID = getShouldUseZendeskSandbox()
  ? "14674871098651"
  : "360016145111";
